// in the case of grow this list we should move logic to the <Layout /> component property like a 'hideConnectionButton'
export default [
    '/_site/[city]/internet',
    '/_site/[city]/full-buy',
    '/_site/[city]/constructor',
    '/_site/[city]/novosel',
    // страницы новосела
    '/_site/[city]/order/[order-id]/address',
    '/_site/[city]/order/[order-id]/contacts',
    '/_site/[city]/order/[order-id]/create-agreement',
    // страницы переезда
    '/_site/[city]/order/[order-id]/time-slots-reissue',
    // страницы full-buy
    '/_site/[city]/order/[order-id]/check-address',
    '/_site/[city]/order/[order-id]/select-equipment',
    '/_site/[city]/order/[order-id]/personal-data',
    '/_site/[city]/order/[order-id]/agreement-processing',
    '/_site/[city]/order/[order-id]/installment-result',
    // общие страницы core-request'a (но у переезда своя страница тайм-слотов)
    '/_site/[city]/order/[order-id]/time-slots',
    '/_site/[city]/order/[order-id]/final',
];
